import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  CircularProgress,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  getAllTermsOfPaymentByType,
  updateCaseTermsOfPayment,
} from "../../../api/termsOfPaymentApi";
import { StyledButton } from "../../../common/components/Button";
import { StyledH3 } from "../../../common/components/Title/styles";
import * as yup from "yup";
import { red } from "@mui/material/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const PaymentTermsSection = ({
  caseId,
  onUpdate,
  getCaseData,
  isBeforeDesign,
}) => {
  const [terms, setTerms] = useState();
  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setError,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        termsOfPaymentId: yup
          .string("Invalid")
          .required("Terms of payment is required"),
      })
    ),
  });

  useEffect(() => {
    const fetchTerms = async () => {
      const terms = await getAllTermsOfPaymentByType(isBeforeDesign ? 0 : 1);
      setTerms(terms);
    };
    fetchTerms();
  }, []);

  const handleTermsSubmit = async (values) => {
    try {
      const response = await updateCaseTermsOfPayment(
        caseId,
        values.termsOfPaymentId,
        isBeforeDesign ? 0 : 1
      );
      onUpdate(values.termsOfPaymentId, isBeforeDesign);
      await getCaseData();
    } catch (err) {
      setError("submission", {
        type: "custom",
        message: err.data.message,
      });
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "10px",
        padding: 4,
        border: "1px solid #d6d6d6",
        marginBottom: "10px",
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        spacing={1}
        sx={{
          marginBottom: "1rem",
        }}
      >
        <FontAwesomeIcon
          fontSize="22px"
          icon={faExclamationTriangle}
          color="#ff9800"
        />
        <StyledH3
          theme="green"
          style={{
            marginY: 0,
            paddingTop: 0,
          }}
        >
          {isBeforeDesign
            ? "Select Terms of Payment before Design"
            : "Select Terms of Payment after Design"}
        </StyledH3>
      </Stack>
      <form onSubmit={handleSubmit(handleTermsSubmit)}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Controller
            control={control}
            name="termsOfPaymentId"
            render={({ field: { onChange }, fieldState: { error } }) => (
              <Autocomplete
                autoHighlight
                disablePortal
                options={terms}
                onChange={(_, val) => {
                  onChange(val?.id || "");
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name || option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(error)}
                    FormHelperTextProps={{ variant: "standard" }}
                    helperText={error && error.message}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  );
                }}
                sx={{ width: "100%", maxWidth: "sm" }}
              />
            )}
          />
          <Box sx={{ display: "inline-block" }}>
            <StyledButton
              theme="green"
              type="submit"
              sx={{ width: "100%", maxWidth: "132px" }}
            >
              Select Payment
            </StyledButton>
            {isSubmitting && <CircularProgress />}
          </Box>
        </Stack>
        {errors.submission && (
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: red[400],
              marginTop: 1,
            }}
          >
            {errors.submission?.message}
          </Typography>
        )}
      </form>
    </Box>
  );
};

export default PaymentTermsSection;
